import { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";

import { api, cleanAIAnswer, parseArray, robustJsonParse, speakGerman } from "../pureFunctions";
import { Button, Form, Col, Alert, Row, Spinner, Table, ButtonGroup } from "react-bootstrap";
import { header } from "../globalVariables";

import aiIcon from "../img/ki.png";
import editIcon from "../img/edit.png";

import { milieuForm, milieuOutputConfig, milieuPrompt, milieuTexte } from "./MilieuData";
import TextMitZeilennummern from "../Zeilennummern";
import NummerierteSaetze from "../NummerierteSaetze";
import { formatText } from "../formatFunctions";
import { useContextMenu, ContextMenu, getItemsForContext } from "../Utils/ContextMenu";
import MyProgressBar from "../Tools/MyProgressBar";
import { SpinnerGroup } from "../Utils/SpinnerGroup";
import { debouncedSaveEstateData, saveEstateData } from "../networkFunctions";
import LoadingAnimation from "../LoadingAnimation";

export default function AIExpoMilieu({
   estateId,
   selectedModel,
   getCleanData,
   milieuData,
   setMilieuData,
   aiLoading,
   setAiLoading,
   user,
}) {
   function changeMilieuData(type, value, key) {
      let updatedMilieuData = structuredClone(milieuData);
      if (type === "options") {
         if (!Array.isArray(updatedMilieuData[type][key])) {
            updatedMilieuData[type][key] =
               updatedMilieuData[type][key] !== undefined ? [updatedMilieuData[type][key]] : [];
         }
         if (updatedMilieuData[type][key].includes(value)) {
            updatedMilieuData[type][key] = updatedMilieuData[type][key].filter((item) => item !== value);
         } else {
            updatedMilieuData[type][key].push(value);
         }
      } else if (type === "text") {
         updatedMilieuData.options[key] = value;
      } else if (type === "result") {
         updatedMilieuData[type] = value;
         updatedMilieuData.selected = value.primaerMilieu;
      } else if (type === "selected") {
         updatedMilieuData[type] = value;
      }
      setMilieuData(updatedMilieuData);
      debouncedSaveEstateData({ milieu: updatedMilieuData }, estateId);
   }

   async function generateMilieu() {
      setAiLoading((prev) => ({ ...prev, milieu: "loading" }));
      const cleanData = getCleanData();
      // return false;
      let finalPrompt = milieuPrompt.replace(
         "$DATEN",
         JSON.stringify({ milieuDaten: milieuData, objektDaten: cleanData }, null, 2),
      );

      const content = await api
         .post(
            `api/ai_prompt`,
            {
               model: selectedModel,
               messages: [
                  { role: "system", content: finalPrompt },
                  { role: "user", content: "Führe den systemprompt aus" },
               ],
               outputConfig: milieuOutputConfig,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            console.log(data?.data?.content);

            return robustJsonParse(data?.data?.content ?? data?.content);
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
            setAiLoading((prev) => ({ ...prev, milieu: "error" }));
         });

      console.log(content);

      changeMilieuData("result", content);
      setAiLoading((prev) => ({ ...prev, milieu: false }));
   }

   return (
      <>
         {milieuData.result?.primaerMilieu && (
            <Alert className="my-2 p-4">
               <h3>Ergebnis:</h3>
               <Alert>
                  <h4>
                     Primärmilieu: {milieuData.result.primaerMilieu}{" "}
                     <small>(Konfidenz: {milieuData.result.konfidenz} %)</small>
                  </h4>
                  <h5>
                     Sekundärmilieu: {milieuData.result.sekundaerMilieu}{" "}
                     <small>(Konfidenz: {milieuData.result.sekundaerKonfidenz} %)</small>
                  </h5>
                  <ul>
                     {milieuData.result?.begruendung?.map((item) => (
                        <li key={item}>{item}</li>
                     ))}
                  </ul>
               </Alert>
               <ButtonGroup>
                  <Button
                     variant={
                        "outline-primary " + (milieuData.selected === milieuData.result.primaerMilieu ? "active" : "")
                     }
                     title={milieuTexte?.[milieuData.result.primaerMilieu]?.text}
                     onClick={() => {
                        changeMilieuData("selected", milieuData.result.primaerMilieu);
                     }}
                  >
                     {milieuTexte?.[milieuData.result.primaerMilieu]?.title}
                  </Button>
                  <Button
                     title={milieuTexte?.[milieuData.result.sekundaerMilieu]?.text}
                     variant={
                        "outline-primary " + (milieuData.selected === milieuData.result.sekundaerMilieu ? "active" : "")
                     }
                     onClick={() => {
                        changeMilieuData("selected", milieuData.result.sekundaerMilieu);
                     }}
                  >
                     {milieuTexte?.[milieuData.result.sekundaerMilieu]?.title}
                  </Button>
               </ButtonGroup>
               <ButtonGroup className="mt-2">
                  {Object.keys(milieuTexte)
                     .filter(
                        (item) => ![milieuData.result.primaerMilieu, milieuData.result.sekundaerMilieu].includes(item),
                     )
                     .map((item) => {
                        return (
                           <Button
                              key={item}
                              variant={"outline-secondary " + (milieuData.selected === item ? "active" : "")}
                              title={milieuTexte?.[item]?.text}
                              onClick={() => {
                                 changeMilieuData("selected", item);
                              }}
                           >
                              {milieuTexte?.[item]?.title}
                           </Button>
                        );
                     })}
               </ButtonGroup>
            </Alert>
         )}
         <MyProgressBar
            rounded
            color="#333"
            value={
               100 *
               (Object.values(milieuData.options).filter((item) => item).length / Object.values(milieuForm).length)
            }
         />
         <div
            style={{
               maxHeight: "70vh",
               overflow: "auto",
               scrollbarColor: "#ccc transparent",
               scrollbarWidth: "thin",
            }}
         >
            <Form className="mx-0" style={{ width: "calc( 100% - 20px)" }}>
               <Row>
                  {milieuForm.map((milieuItem, index) => {
                     return (
                        <Col key={"milieuform_" + index} md={milieuItem.width ?? 12} sm={12}>
                           <Form.Group
                              controlId={"milieuitem_" + index}
                              className="mb-2 mt-2"
                              style={{
                                 padding: "20px",
                                 boxShadow: "inset 0 0 8px #ccc",
                                 borderRadius: "20px",
                                 borderLeft: milieuData?.options?.[milieuItem.name] ? "" : "solid 14px #b00",
                              }}
                           >
                              <Form.Label>{milieuItem.heading}:</Form.Label>

                              {milieuItem.options && (
                                 <ButtonGroup
                                    className="w-100 "
                                    vertical
                                    style={{ /* boxShadow: "0 0 6px #0003", */ borderRadius: "10px" }}
                                 >
                                    {milieuItem.options.map((option, index2) => (
                                       <Button
                                          className={
                                             "text-start " +
                                             (milieuData?.options?.[milieuItem.name]?.includes(option) ? " active" : "")
                                          }
                                          variant="light"
                                          key={index + "option_" + index2}
                                          onClick={() => {
                                             changeMilieuData("options", option, milieuItem.name);
                                          }}
                                       >
                                          • {option}
                                       </Button>
                                    ))}
                                 </ButtonGroup>
                              )}
                              {milieuItem.textarea && (
                                 <Form.Control
                                    as="textarea"
                                    placeholder=""
                                    onChange={(e) => {
                                       changeMilieuData("text", e.target.value, milieuItem.name);
                                    }}
                                    name={milieuItem.name}
                                    value={milieuData?.options?.[milieuItem.name]}
                                    style={{ minHeight: "115px", fieldSizing: "content" }}
                                 />
                              )}
                           </Form.Group>
                        </Col>
                     );
                  })}
               </Row>
            </Form>
         </div>

         <Button
            className="my-2 w-100"
            style={{ background: "#047" }}
            disabled={
               aiLoading?.milieu === "loading" ||
               (() => {
                  return !milieuForm.every((item) => milieuData?.options[item.name]);
               })()
            }
            onClick={() => {
               generateMilieu();
            }}
         >
            {aiLoading?.milieu === "loading" ? <LoadingAnimation /> : <span>Milieu ermitteln</span>}
         </Button>
      </>
   );
}
